import { forwardRef } from 'react';

import { IconButton, IconButtonProps, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

// Preserves the look of BUI's IconButton variant="secondary", which MUI v4
// cannot express through theme overrides (IconButton has no variant concept).
// TODO: Remove in the Encore migration — icon buttons should not diverge from
// the theme's default styling in the final state.
const useStyles = makeStyles({
  root: {
    backgroundColor: 'var(--bui-bg-neutral-2)',
    borderRadius: 'var(--bui-radius-2)',
    width: 32,
    height: 32,
    // Doubled class beats MUI's `.MuiIconButton-root.Mui-disabled`
    // which otherwise resets the background to transparent.
    '&&:disabled': {
      backgroundColor: 'var(--bui-bg-neutral-2-disabled)',
    },
  },
});

export type SecondaryIconButtonProps = IconButtonProps;

export const SecondaryIconButton = forwardRef<
  HTMLButtonElement,
  SecondaryIconButtonProps
>(({ className, size = 'small', ...props }, ref) => {
  const classes = useStyles();

  return (
    <IconButton
      ref={ref}
      size={size}
      className={classNames(classes.root, className)}
      {...props}
    />
  );
});

SecondaryIconButton.displayName = 'SecondaryIconButton';
